import { useContext, useState } from "react";
import MultiStepLaout from "../../../layout/multiStepLayout";
import { Steps } from "../../../layout/multiStepLayout/multiStep";
import { useNavigate } from "react-router";
import { DataMapping, Field } from "../dataMapping";
import TestConnectionModule from "../testConnection";
import HubSpotConnectionSuccesful from "../success";
import HubSpotConnectionFailed from "../failed";
import useFetchData from "../../../hooks/useFetchData";
import MyLoader from "../../../component/loader";
import { ActionIcon } from "rizzui/action-icon";
import { Text } from "rizzui/typography";
import { AuthContext } from "../../../context/authContext";

export default function HubSpotIntegration() {
  const [currentPage, setCurrentPage] = useState("data-mapping");
  const [connectionStatus, setConnectionStatus] = useState<string>("");
  const {
    data: hubspotFeilds,
    isLoading,
    error,
  } = useFetchData({ dataType: "hubspot_data_mapping", isPost: true });

  const required = hubspotFeilds?.data?.requiredFields;
  const optional = hubspotFeilds?.data?.optionalFields;
  const requiredFields: Field[] =
    typeof required === "object"
      ? Object.keys(required).map((field) => ({
          ringconnect: field,
          HubSpot: required[field],
        }))
      : [];
  const optionalFields: Field[] =
    typeof optional === "object"
      ? Object.keys(optional).map((field) => ({
          ringconnect: field,
          HubSpot: optional[field],
        }))
      : [];

  const data: Steps[] = [
    {
      title: "Authenticate",
      subtitle: "CRM connection setup",
      pageId: "authenticate",
    },
    {
      title: "Data Mapping",
      subtitle: "To ensure proper sync",
      pageId: "data-mapping",
    },
    {
      title: "Test connection",
      subtitle: "To check everything works",
      pageId: "test-connection",
    },
  ];
  const navigate = useNavigate();
  const { token } = useContext(AuthContext);

  const conditionalComponent = () => {
    if (isLoading) return <MyLoader />;
    else if (error)
      return (
        <div className="w-fit mx-auto flex flex-col justify-center items-center font-switzer">
          <Text className="font-[400] text-primary-dark">{error.message}</Text>
          <ActionIcon className="!w-fit !h-fit !p-0 !m-0 !bg-transparent !text-[#758599] underline font-[500] text-[13px]">
            Go to dashboard
          </ActionIcon>
        </div>
      );
    switch (currentPage) {
      case "authenticate":
        return <div>Authentication Component</div>;
      case "data-mapping":
        return (
          <DataMapping
            defaultFields={requiredFields ?? []}
            optionalFields={optionalFields ?? []}
            type="HubSpot"
            onSubmit={() => setCurrentPage("test-connection")}
            token={token!}
          />
        );
      case "test-connection":
        return connectionStatus === "success" ? (
          <HubSpotConnectionSuccesful
            parameters={[
              "Authentication verified",
              "Data mapping configured",
              "Test record created successfully",
            ]}
            type="HubSpot"
            onSubmit={setConnectionStatus}
            onBack={setCurrentPage}
          />
        ) : connectionStatus === "failed" ? (
          <HubSpotConnectionFailed
            onSubmit={setConnectionStatus}
            onBack={setCurrentPage}
          />
        ) : (
          <TestConnectionModule
            onBack={setCurrentPage}
            onSubmit={setConnectionStatus}
            type="HubSpot"
          />
        );
      default:
        return null;
    }
  };

  return (
    <MultiStepLaout
      multiStep={data}
      pageInfo={{
        title: "HubSpot Integration",
        subtitle: "Follow these simple steps",
      }}
      currentPage={currentPage}
      closeFunction={() => navigate("/campaigns")}
    >
      {conditionalComponent()}
    </MultiStepLaout>
  );
}
